import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-chenggong",
  "use": "icon-chenggong-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-chenggong\"><path fill=\"#319E55\" d=\"M512 64a448 448 0 1 1 0 896A448 448 0 0 1 512 64z m0 64a384 384 0 1 0 0 768A384 384 0 0 0 512 128z m204.8 224l51.2 50.304L460.8 704 256 502.848l51.2-50.304L460.8 603.52l256-251.456z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol